import { useMobile } from '@/lib/hooks/useMobile';
import Image from 'next/legacy/image';

import { breakpoints, imageLoaderResponsive, } from '@/theme/lib';
import { formatTime } from '@lib/date';

import { TodayAtTheZooCardFragment } from '@/__generated__/graphql';
import { StyledFlexContainer, StyledLeftDiv, StyledPicture, StyledRightDiv, } from "./TodayAtZooCard.styles";


export default function TodayAtZooCard(props: TodayAtTheZooCardFragment) {
  const isMobile = useMobile();

  const { teaserImage } = props;

  return (
    <StyledFlexContainer>
      <StyledLeftDiv>
        {teaserImage && (
          <StyledPicture>
            <Image
              src={teaserImage.url}
              alt={teaserImage.altText || ''}
              layout="intrinsic"
              objectFit="cover"
              sizes={`(min-width: ${breakpoints.sm}px) 345px,
                      (min-width: ${breakpoints.md}px) 590px,
                      345px`}
              width={isMobile ? 345 : 590}
              height={isMobile ? 191 : 348}
              loader={imageLoaderResponsive(isMobile ? 345 : 590, isMobile ? 191 : 348, true)}
            />
          </StyledPicture>
        )}
      </StyledLeftDiv>
      <StyledRightDiv>
        <span>{formatTime(props.startDate)}{props.teaserEyebrow ? ` - ${props.teaserEyebrow}`  : ''}</span>
        <h3>{props.title}</h3>
        <p>{props.teaserDescription}</p>
      </StyledRightDiv>
    </StyledFlexContainer>
  );
}
